module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_7.58ff524a.png";